import React from 'react';
import { Page } from '../Page';
import { Bone, Shield, Sun } from 'lucide-react';
export function SupplementVitaminD() {
  return <Page pageNumber={15} variant="light" data-id="element-3693" data-mp="3tpbpjgagrk4s">
      <div className="flex h-full gap-10" data-id="element-3694" data-mp="3oppad1b2rttc">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3695" data-mp="3orsbohhoh9dd">
          <img src="https://cdn.magicpatterns.com/uploads/f8crb1mnC4CRD44jU5PeSR/pasted-image.png" alt="Thorne Vitamin D3 5000 + K2" className="w-full max-w-[280px] object-contain" data-id="element-3696" data-mp="3knkjgac0hbae" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3697" data-mp="35yfzanlnowzn">
          <div className="mb-6 pt-4" data-id="element-3698" data-mp="35x4v4moatn80">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3699" data-mp="310munz004b1h">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3700" data-mp="2wxqcg9edigy2">
              Vitamin D3 5000 + K2
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3701" data-mp="s4kbk01mneuz">
              Bone + immune support during rapid weight loss
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3702" data-mp="wwlkbbzl6ng9" />
          </div>

          <div className="mb-8" data-id="element-3703" data-mp="j4f820zk10m3">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3704" data-mp="j5gtmze755i2">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3705" data-mp="1aua6qo9ay2nf">
              Rapid weight loss increases the risk of bone density loss. Vitamin
              D3 supports calcium absorption and bone health, while K2 (MK-7)
              directs calcium to bones rather than arteries. Many adults are
              deficient, especially during winter months or with limited sun
              exposure.
            </p>
          </div>

          <div className="mb-8" data-id="element-3706" data-mp="3mirmigzo0jkz">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3707" data-mp="3mmp7z99ptn81">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3708" data-mp="1x37f3c2ionx1">
              <li className="flex gap-2" data-id="element-3709" data-mp="1x5bhfpkrpev7">
                <Bone className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3710" data-mp="1s3uk241hsajd" />
                <span data-id="element-3711" data-mp="1nde68itremwh">
                  Supports bone density and strength during caloric deficit and
                  weight loss
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3712" data-mp="1j9pz2191htbr">
                <Shield className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3713" data-mp="1ed900c0axujw" />
                <span data-id="element-3714" data-mp="19dml7y4ts68z">
                  Enhances immune function (which can dip during rapid metabolic
                  change)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3715" data-mp="14ethuyj95vmj">
                <Sun className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3716" data-mp="10d81323lkx72" />
                <span data-id="element-3717" data-mp="10fb02bmqa0nx">
                  K2 MK-7 ensures calcium goes to bones, not blood vessels,
                  critical for cardiovascular health
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3718" data-mp="2uov61hg7ee16">
                <span className="text-tealslate shrink-0" data-id="element-3719" data-mp="gjzxkcs3bhy5">•</span>
                <span data-id="element-3720" data-mp="ghdmi35zqkb6">
                  125mcg (5000 IU) D3 per capsule, therapeutic dose for
                  deficiency correction
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3721" data-mp="ualevx1wbjtx">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3722" data-mp="u9juh1yzpkzj">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3723" data-mp="3tq9p652rs2ye">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3724" data-mp="2jyvwv4046hm">
                <strong data-id="element-3725" data-mp="6kit1yokra3r">1 capsule daily</strong> with a meal containing fat
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3726" data-mp="bjvfwjfg4h6c">
                125mcg (5000 IU) Vitamin D3 + K2 MK-7 per capsule
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3727" data-mp="1hzxogy14xtwr">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3728" data-mp="1myr16o8llgvv" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3729" data-mp="1gkla8hpbbne6">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}